import { render } from "./ProjectTab.vue?vue&type=template&id=d011e53a&scoped=true&ts=true"
import script from "./ProjectTab.ts?vue&type=script&lang=ts"
export * from "./ProjectTab.ts?vue&type=script&lang=ts"

import "./ProjectTab.scss?vue&type=style&index=0&id=d011e53a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d011e53a"]])

export default __exports__